// extracted by mini-css-extract-plugin
export var cardIcon = "_6i-4";
export var checkboxCard = "_6i-0";
export var checkboxCardSelected = "_6i-1";
export var disabled = "_6i-2";
export var outerBorder = "_6i-3";
export var spacerMedium = "_6i-7";
export var spacerSmall = "_6i-6";
export var spacerXsmall = "_6i-5";